var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSend(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.9315 0.176793C17.7416 0.275116 15.6808 1.33873 13.3521 2.54037C11.0234 3.74202 7.1298 5.7512 4.69968 7.00526C2.2696 8.25935 0.240932 9.32212 0.191572 9.36704C0.0804098 9.46819 0 9.64887 0 9.79762C0 9.9434 0.12483 10.184 0.238741 10.2577C0.368585 10.3418 5.31473 12.0059 5.37115 11.9845C5.39734 11.9746 6.10906 11.3827 6.95272 10.6693C7.79641 9.95581 10.1079 8.00383 12.0893 6.33149C14.0708 4.65919 15.7329 3.25609 15.783 3.21348L15.8741 3.136L15.783 3.24743C15.7329 3.30872 13.912 5.47785 11.7365 8.0677C9.56097 10.6576 7.77676 12.7876 7.7716 12.8012C7.7645 12.8198 15.7402 15.5332 16.1451 15.6498C16.3331 15.704 16.6629 15.5421 16.7659 15.3452C16.8404 15.2029 19.0293 0.611632 18.9997 0.455321C18.9698 0.297761 18.8143 0.113079 18.6569 0.0480805C18.4449 -0.0394527 18.2994 -0.0136515 17.9315 0.176793ZM6.94533 15.6898C6.94533 17.7455 6.94128 17.7032 7.15372 17.8683C7.39856 18.0586 7.72959 18.0409 7.93654 17.8265C8.08637 17.6712 10.1492 14.8962 10.1293 14.8766C10.1145 14.862 6.98811 13.7978 6.95985 13.7978C6.95186 13.7978 6.94533 14.6492 6.94533 15.6898Z",
    fill: "#0D0B1D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.1d4ab422d877f2e122285199dc40d85a.svg";
export { ForwardRef as ReactComponent };